import React, { useState } from 'react'

const TaskForm = ({ onAddTask }) => {
  const [newTaskText, setNewTaskText] = useState('')

  const handleSubmit = e => {
    e.preventDefault()
    if (newTaskText.trim() === '') return

    onAddTask(newTaskText)
    setNewTaskText('')
  }

  return (
    <form onSubmit={handleSubmit} className='task-form'>
      <input type='text' value={newTaskText} onChange={e => setNewTaskText(e.target.value)} placeholder='Afegeix una nova tasca...' />
      <button type='submit'>Afegir</button>
    </form>
  )
}

export default TaskForm
